var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',{attrs:{"href":"#close","aria-label":_vm.$root.translate('Close'),"aria-hidden":"true"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }